/* Buybox review carousel: autoplay + frecce + dots + swipe.
   Scorre "sul posto": slide impilate (grid), transizione opacity/translate. */
(function () {
  'use strict';

  var AUTOPLAY_MS = 6000;
  var RESUME_MS = 12000;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.buybox-rev-slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rev-dot]'));
    var prevBtn = root.querySelector('[data-rev-prev]');
    var nextBtn = root.querySelector('[data-rev-next]');
    var index = 0;
    var timer = null;
    var resumeTimer = null;
    var visible = true;

    function goTo(next) {
      next = (next + slides.length) % slides.length;
      if (next === index) return;
      var current = slides[index];
      current.classList.remove('is-active');
      current.classList.add('is-exit');
      current.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(current.querySelectorAll('.is-expanded'), function (p) { p.classList.remove('is-expanded'); });
      root.classList.remove('is-reading');
      setTimeout(function () { current.classList.remove('is-exit'); }, 500);
      slides[next].classList.add('is-active');
      slides[next].setAttribute('aria-hidden', 'false');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === next); });
      index = next;
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (reduced || timer || !visible || root.classList.contains('is-reading')) return;
      timer = setInterval(function () { goTo(index + 1); }, AUTOPLAY_MS);
    }

    function interact(fn) {
      return function (e) {
        if (e && e.preventDefault && e.type === 'click') e.preventDefault();
        stop();
        if (resumeTimer) clearTimeout(resumeTimer);
        fn();
        resumeTimer = setTimeout(start, RESUME_MS);
      };
    }

    if (prevBtn) prevBtn.addEventListener('click', interact(function () { goTo(index - 1); }));
    if (nextBtn) nextBtn.addEventListener('click', interact(function () { goTo(index + 1); }));
    dots.forEach(function (d, i) {
      d.addEventListener('click', interact(function () { goTo(i); }));
    });

    // Swipe manuale
    var startX = null;
    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? index + 1 : index - 1);
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(start, RESUME_MS);
    }, { passive: true });

    // Pausa su hover (desktop)
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () {
      if (resumeTimer) clearTimeout(resumeTimer);
      start();
    });

    // Autoplay solo quando visibile
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0.3 }).observe(root);
    } else {
      start();
    }
  }

  // Testo a 3 righe: tocco/click per leggerlo tutto (ferma l'autoplay finché aperto)
  function initExpand(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-rev-text]'), function (p) {
      p.setAttribute('title', 'Read the full review');
      p.addEventListener('click', function () {
        var open = p.classList.toggle('is-expanded');
        root.classList.toggle('is-reading', open);
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rev-carousel]'), initExpand);
    Array.prototype.forEach.call(document.querySelectorAll('[data-rev-carousel]'), initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
